import React, { Component, useState } from "react";
import { hot } from "react-hot-loader";
import { AppContext } from "../../AppContext";
import ReusableStepPromo from "../common/promo/ReusableStepPromo";
import { actAsPremium } from "../common/promo/hooks";
import {
  Button,
  Form,
  Input,
  notification,
  Table,
  Spin,
  Tooltip,
  Row,
  Col,
  Popover,
  Icon
} from "antd";
//import { TestCaseStepInputCollection } from "../TestCaseAdd/TestCaseStepInputCollection";
import { ReusableStepsApi, ReusableStep } from "../../services/generated-sdk";
import { FormCreateOption } from "antd/lib/form";
import Search from "antd/lib/input/Search";
import { sanitize } from "../../utils/common";
import NoData from "../common/layout/NoData";
const _ = require("lodash");

function SelectReusableStepStatic({ history, match, ...props }) {
  const [loadingSteps, setLoadingSteps] = React.useState(false);
  const { projectId } = React.useContext(AppContext);
  const [state, setState] = useState({});
  const [reusableSteps, setReusableSteps] = React.useState<
    ReusableStep[] | null
  >([]);
  const [filtered, setFiltered] = React.useState<ReusableStep[]>([]);
  let searchInput;

  const [isAccessAllowed] = actAsPremium();
  if (!isAccessAllowed) {
    return <ReusableStepPromo />;
  }

  React.useEffect(() => {
    // setReusableSteps(props.reusableSteps);
    if (
      !props.reusableSteps ||
      (props.reusableSteps instanceof Array && props.reusableSteps.length == 0)
    ) {
      fetchSteps();
    } else {
      setReusableSteps(props.reusableSteps);
      setFiltered(props.reusableSteps);
    }
  }, []);

  const service = new ReusableStepsApi();
  const fetchSteps = async () => {
    if (!props.canAddReusableSteps) {
      return;
    }
    setLoadingSteps(true);
    const steps = await service.getAllReusableSteps({ project: projectId });
    //console.log("STEPS", steps);

    setReusableSteps(steps && steps.length ? steps : null);
    setFiltered(steps);
    setLoadingSteps(false);
  };

  // if (!reusableSteps) {
  //   return <Spin tip="loading reusable steps..." />;
  // }

  const getStepsList = (record, i) => {
    return (
      <Row gutter={24} key={`step_${i}`}>
        <Col span={12}>
          <b>#{i + 1}. </b>
          <div
            dangerouslySetInnerHTML={{
              __html: sanitize(record.step)
            }}
          />
        </Col>
        <Col span={12}>
          {record.expectedResult ? (
            <div
              dangerouslySetInnerHTML={{
                __html: sanitize(record.expectedResult)
              }}
            />
          ) : (
            "NA"
          )}
        </Col>
      </Row>
    );
  };

  const handleSearch = e => {
    const value = e.currentTarget.value;
    setLoadingSteps(true);
    let filtered = reusableSteps.filter(record =>
      record["name"]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase())
    );
    setFiltered(filtered);
    setLoadingSteps(false);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => {
        return (
          <span>
            <Popover
              placement="right"
              content={
                <div>
                  <Row>
                    <Col span={12}>
                      <b>Step: </b>
                    </Col>
                    <Col span={12}>
                      <b>Expected Result: </b>
                    </Col>

                    {_.map(record.steps, getStepsList)}
                  </Row>
                </div>
              }
            >
              <span
                style={{
                  textDecoration: "underline dotted",
                  color: "inherit",
                  textDecorationColor: "#cac9c9"
                }}
              >
                {text}
              </span>
            </Popover>
          </span>
        );
      }
    },
    {
      title: "",
      width: 120,
      key: "action",
      //width: "50px",
      className: "action",
      render: record => (
        <span>
          <Button onClick={() => onStepSelect(record)} type="primary">
            Select
          </Button>
        </span>
      )
    }
  ];

  const onStepSelect = step => {
    var event = new CustomEvent("reusableStepSelected", { detail: step });
    window.dispatchEvent(event);
  };

  return (
    <div>
      <br />
      <div style={{ display: "flex" }}>
        <h3 style={{ float: "left", flex: 2 }}>Select Reusable Step</h3>
        <Search
          placeholder="Search by name"
          style={{ width: 250 }}
          onChange={handleSearch}
        />
      </div>
      <br />
      {reusableSteps ? (
        <Table
          columns={columns}
          rowKey="id"
          dataSource={filtered}
          loading={loadingSteps}
          pagination={false}
          size="small"
        />
      ) : (
        <NoData title="You do not have any reusable steps yet!" />
      )}
    </div>
  );
}
interface Props {
  reusableSteps?: ReusableStep[];
  form: any;
  canAddReusableSteps: boolean;
}
const mapPropsToFields = { mapPropsToFields(props: Props) {} };
const FormOptions: FormCreateOption<Props> = mapPropsToFields;
const SelectReusableStep = Form.create(FormOptions)(SelectReusableStepStatic);
export default SelectReusableStep;
